<template>
<v-container style="margin: 0px; padding: 0px; max-width:100%">
    <v-app-bar v-if="title != null" color="indigo" dark dense :style="{ 
      position: 'fixed',
      top: '50px',
      right: 0,
      width: '100%',
      border: '3px solid #73AD21'
    }">
      <v-spacer/>
      <v-toolbar-title><h3>Policy Documents ({{title}})</h3></v-toolbar-title>
      <v-icon @click="close" style="padding-left: 10px;">mdi-close</v-icon>
    </v-app-bar>
  <div style="padding-top: 20px;" />
  <div v-html="html" style="margin: 40px;">
  </div>
</v-container>
</template>

<script>
export default {
  props: ['title', 'html'],
  methods: {
    close() {
      this.$router.go(-1)
    }
  },
  mounted () {
    // console.log('html: ', this.f)
  }
}
</script>
<style scoped>
.abar {
  position: fixed;
}
</style>